import { render, staticRenderFns } from "./InstallationDetail_Adventures.vue?vue&type=template&id=0b53e086&scoped=true&"
import script from "./InstallationDetail_Adventures.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_Adventures.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InstallationDetail_Adventures.vue?vue&type=style&index=1&id=0b53e086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53e086",
  null
  
)

export default component.exports